import { createSolidStreamingMarkdown, SolidStreamingMarkdown } from "@storytell/markdown";
import { compactMarkdownOptions, defaultMarkdownOptions } from "../../block/markdownOptions";

// The parser is seeded once at mount, so later changes to the prop are ignored.
// Only for content that is whole by the time its card renders; a card that
// streams needs the delta streamer instead. Provider content inside a tool card
// renders compact (the activity's size); pass size="base" for text that stands
// in the conversation itself, such as a user's interjection.
export const CompleteMarkdown = (props: { markdown: string; size?: "compact" | "base" }) => {
  const streamer = createSolidStreamingMarkdown(props.markdown);
  return (
    <div classList={{ "text-sm": props.size !== "base" }}>
      <SolidStreamingMarkdown
        doc={streamer.doc}
        options={props.size === "base" ? defaultMarkdownOptions : compactMarkdownOptions}
      />
    </div>
  );
};
